export const voice = (state = null, action) => {
    switch (action.type) {
        case 'VOICE_SAY':
            return action.text;
        default:
            return state
    }
};
